import React from "react";
import { useTranslation } from "react-i18next";

import './autoUpdate.scss'

import AutoUpdateGif from '../../../../assets/agileDashboards/gifs/gif4.gif'


function AutoUpdate() {
    const { t } = useTranslation()

    return (
        <div className="container-autoupdate">
            <div className="img-autoupdate">
                <img src={AutoUpdateGif} alt="" />
            </div>
            <div className="texts-autoupdate">
                <h1>{t("rapid_dashboard.auto_update.title")}</h1>
                <p>{t("rapid_dashboard.auto_update.section_text_1")}</p>
                <p>{t("rapid_dashboard.auto_update.section_text_2")}</p>
            </div>
        </div>
    )
}


export default AutoUpdate